import { useTheme } from "@/context/ThemeContext";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggleTheme } = useTheme();
  return (
    <button
      onClick={toggleTheme}
      data-testid="theme-toggle"
      aria-label="Toggle theme"
      className={`relative w-9 h-9 sm:w-10 sm:h-10 rounded-full glass flex items-center justify-center transition-transform hover:scale-110 ${className}`}
    >
      {theme === "dark"
        ? <Moon className="w-4 h-4 text-primary-c" />
        : <Sun className="w-4 h-4 text-primary-c" />}
    </button>
  );
}
